import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import _ from 'lodash'

import SelectLineItems from '../../containers/SelectLineItems'

const SelectInvoiceLineItems = ({
    i18n,
    defaultLineItems,
    initialData,
    loading,
    onFetchInitialData,
    onSelectLineItemsChange,
    orderId,
    vatIncluded
}) => {
    const renderLineItemDetail = (name, lineItem) => {
        if (_.get(lineItem, 'item_type', '') === 'ServiceLineItem') {
            return (
                <div style={{ paddingLeft: 16 }}>
                    ↳ {name}
                </div>
            )
        }

        return name
    }

    const vatIndicator = i18n.t(vatIncluded ? 'inquiries:vatIncluded' : 'inquiries:vatExcluded')

    const columns = [{
        title: i18n.t('inquiries:detail'),
        dataIndex: 'name',
        editable: true,
        render: renderLineItemDetail
    }, {
        title: i18n.t('inquiries:quantity'),
        dataIndex: 'quantity',
        editable: true
    }, {
        title: i18n.t('inquiries:unit'),
        dataIndex: 'unit',
        editable: true
    }, {
        title: `${i18n.t('inquiries:unitPrice')} (${vatIndicator})`,
        dataIndex: 'single_price',
        editable: true
    }, {
        title: i18n.t('inquiries:emptyLineBelow'),
        dataIndex: 'empty_line_below',
        editable: true
    }]

    return (
        <SelectLineItems
            columns={columns}
            dataSource={initialData}
            loading={loading}
            onChange={onSelectLineItemsChange}
            onFetch={onFetchInitialData}
            orderId={orderId}
            value={defaultLineItems} />
    )
}

SelectInvoiceLineItems.propTypes = {
    defaultLineItems: PropTypes.array,
    initialData: PropTypes.array,
    loading: PropTypes.bool,
    onFetchInitialData: PropTypes.func,
    onSelectLineItemsChange: PropTypes.func,
    orderId: PropTypes.string.isRequired,
    vatIncluded: PropTypes.bool
}

SelectInvoiceLineItems.defaultProps = {
    defaultLineItems: [],
    onSelectLineItemsChange: () => {},
    vatIncluded: false
}

export default withTranslation(['inquiries'])(SelectInvoiceLineItems)
